export default __webpack_public_path__ + "static/media/chat-expand.32923c35.svg";